export const vendorsTranslations: Record<string, { title: string; subtitle: string }> = {
  pt: {
    title: "Fornecedores",
    subtitle: "Gerir relações com fornecedores e despesas",
  },
  en: {
    title: "Vendors",
    subtitle: "Manage your vendor relationships and expenses",
  },
  es: {
    title: "Proveedores",
    subtitle: "Gestiona tus relaciones con proveedores y gastos",
  },
  et: {
    title: "Tarnijad",
    subtitle: "Halda tarnijasuhteid ja kulusid",
  },
  de: {
    title: "Lieferanten",
    subtitle: "Verwalten Sie Lieferantenbeziehungen und Ausgaben",
  },
  fr: {
    title: "Fournisseurs",
    subtitle: "Gérez vos relations fournisseurs et vos dépenses",
  },
  it: {
    title: "Fornitori",
    subtitle: "Gestisci i rapporti con i fornitori e le spese",
  },
  nl: {
    title: "Leveranciers",
    subtitle: "Beheer leveranciersrelaties en uitgaven",
  },
  sv: {
    title: "Leverantörer",
    subtitle: "Hantera leverantörsrelationer och utgifter",
  },
  da: {
    title: "Leverandører",
    subtitle: "Administrer leverandørrelationer og udgifter",
  },
  fi: {
    title: "Toimittajat",
    subtitle: "Hallitse toimittajasuhteita ja kuluja",
  },
};
